import { useStorage } from '@vueuse/core'
import { SAFE_MIN_WINDOW_WIDTH_TWO_SIDEBARS, useSidebarStore } from './sidebar'

export const useLeftSidebarStore = defineStore('left-sidebar', () => {
  const isOpen = useStorage<boolean>('is_left_sidebar_open', false)

  const toggleSidebar = (value?: boolean) => {
    if (value !== undefined)
      isOpen.value = value

    else
      isOpen.value = !isOpen.value

    if (isOpen.value && window.innerWidth < SAFE_MIN_WINDOW_WIDTH_TWO_SIDEBARS)
      useSidebarStore().state.isOpen = false
  }

  return {
    isOpen,
    toggleSidebar,
  }
})
